import { ReactElement, ReactNode } from 'react'

import { Button, type ButtonProps } from 'antd'

import { useAuthDomainValue } from 'hooks'

type Props = Omit<ButtonProps, 'htmlType' | 'type' | 'loading'> & {
    children: ReactNode
}

const SubmitButton = ({
    children,
    className,
    ...rest
}: Props): ReactElement => {
    const isSubmitting: boolean = useAuthDomainValue('isFetching')
    return (
        <Button
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
            size="large"
            data-cy="submit-button"
            className={className}
            {...rest}
        >
            {children}
        </Button>
    )
}

export default SubmitButton
